import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './initialState.js'
import { validateAllFields } from './validation.js'
import { validateMinMax } from '../genericFunctions/index.js'
import dataProvider from '../../../lib/dataProvider.js'

const data = dataProvider.osb

const osbSlice = createSlice({
    name: 'osbShoe',
    initialState,
    reducers: {
        osbShoeData (state, action) {
            const key = action.payload.key
            const value = action.payload.value === null ? '' : action.payload.value
            const side = action.payload.side || ''
            switch (key) {
            default:
                if (side === '') {
                    state.osbShoeData[key] = value
                } else {
                    if (side === 'left' && state.osbShoeData.left[key] === state.osbShoeData.right[key]) {
                        state.osbShoeData.left[key] = value
                        state.osbShoeData.right[key] = value
                    } else {
                        state.osbShoeData[side][key] = value
                    }
                }
                // check if theres a minMax value
                if (data[key] !== undefined && data[key].min !== undefined) {
                    validateMinMax(data[key], state, action, 'osbShoeErrors')
                }
                break
            }
        },
        osbShoeAccordion (state, action) {
            switch (action.payload.key) {
            case 'accordion':
                if (!state.osbShoeAccordion.hasBeenOpened && state.osbShoeAccordion.accordion && !action.payload.value) {
                    state.osbShoeAccordion.hasBeenOpened = true
                }
                state.osbShoeAccordion.accordion = action.payload.value
                validateAllFields(state, action)
                break
            case 'validate':
                validateAllFields(state, action)
                break
            case 'validateFalse':
                state.osbShoeAccordion.validate = false
                break
            case 'hasBeenOpened':
                state.osbShoeAccordion.hasBeenOpened = true
                break
            }
        },
        osbShoeClose (state) {
            state.osbShoeAccordion.accordion = false
            state.osbShoeAccordion.hasBeenOpened = true
            validateAllFields(state)
        },
        importOsbShoe (state, action) {
            state.osbShoeData = action.payload
        },
        resetState (state) {
            state.osbShoeData = initialState.osbShoeData
        }
    }
})

export const { resetState, osbShoeData, osbShoeAccordion, importOsbShoe, osbShoeClose } = osbSlice.actions
export default osbSlice.reducer
